import React, { useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { useTemplatesStudio } from 'api/useTemplatesStudio';
import { useTemplateStudioState } from 'state/hooks/template-studio.hook';
import { EToasterStatus, showToast } from 'utils/showToast';

import DialogModal from 'components/DialogModal/DialogModal';

export const TemplatesStudioDeleteDialog: React.FC = () => {
  const { publisherId } = useParams();
  const { deleteTemplate } = useTemplatesStudio(publisherId);
  const { templateIdToDelete, setTemplateIdToDelete } =
    useTemplateStudioState();

  const handleDelete = () => {
    deleteTemplate.mutate(templateIdToDelete!, {
      onSuccess: () => {
        showToast({
          message: 'Template deleted successfully',
          status: EToasterStatus.SUCCESS
        });
      },
      onError: () => {
        showToast({
          message: 'Error deleting template',
          status: EToasterStatus.ERROR
        });
      },
      onSettled: () => {
        setTemplateIdToDelete(undefined);
      }
    });
  };

  useEffect(() => {
    return () => {
      const body = document.body;
      if (body.style.pointerEvents === 'none') {
        body.style.pointerEvents = '';
      }
    };
  }, []);

  return (
    <DialogModal
      isOpen={true}
      onOpenChange={(open: boolean) => {
        if (!open) setTemplateIdToDelete(undefined);
      }}
      title={'Delete Template'}
      description={
        'Are you sure you want to delete this template? This action cannot be undone and will permanently remove the template from your account.'
      }
      modalActions={{
        onConfirm: {
          label: 'Delete',
          action: () => handleDelete(),
          variant: 'destructive'
        },
        onClose: {
          label: 'Cancel',
          action: () => setTemplateIdToDelete(undefined),
          variant: 'link'
        }
      }}
    />
  );
};
